module.exports = __webpack_public_path__ + "static/media/foto2.6416a6cb.png";